export default "__VITE_ASSET__BgOE0N_L__"